import { Injectable } from "@angular/core";
import { IActivityLog, IPatient } from "@comunicare/comunicare-interfaces";
import { Observable } from "rxjs";
import { ActivityApiService } from "./api/activity-api.service";

@Injectable({
  providedIn: "root",
})
export class ActivityService {
  constructor(private activityApiService: ActivityApiService) {}

  public log(patient: IPatient) {
    return this.activityApiService.log(patient);
  }

  public list(): Observable<IActivityLog[]> {
    return this.activityApiService.list() as Observable<IActivityLog[]>;
  }
}
